import React, { useState } from 'react';
import siteContent from '../../content/siteContent'; // Adjust path if necessary
import { useNavigate } from 'react-router-dom';
import './WelcomePage.css';

function WelcomePage() {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [lang, setLang] = useState('EN'); // Added for multi-lingual structural support
    const navigate = useNavigate();

    // Accessing privacy policy data layer dynamically based on chosen language
    const { privacyPolicy } = siteContent;
    const currentPolicy = privacyPolicy[lang]; 

    const handleContinue = () => {
        if (isChecked) {
            navigate('/chat');
        }
    };

    return (
        <div className="privacy-policy-wrapper">
            <div className="privacy-policy-container">
                
                {/* Language Switcher Control */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginBottom: '16px' }}>
                    <button 
                        onClick={() => setLang('EN')} 
                        style={{ fontWeight: lang === 'EN' ? 'bold' : 'normal', cursor: 'pointer', background: 'none', border: 'none', color: lang === 'EN' ? '#9D00FF' : '#666' }}
                    >
                        English
                    </button>
                    <span>|</span>
                    <button 
                        onClick={() => setLang('HI')} 
                        style={{ fontWeight: lang === 'HI' ? 'bold' : 'normal', cursor: 'pointer', background: 'none', border: 'none', color: lang === 'HI' ? '#9D00FF' : '#666' }}
                    >
                        हिन्दी
                    </button>
                </div>

                {/* Header Section */}
                <div className="privacy-policy-header">
                    <img src="/images/icon.png" alt="Logo" className="privacy-policy-logo" />
                    <span className="privacy-policy-eyebrow">{currentPolicy.badge}</span>
                    <h1 className="privacy-policy-title">{currentPolicy.title}</h1>
                    <p className="privacy-policy-intro">{currentPolicy.subtitle}</p>
                </div>

                {/* Collapsible Policy Section */}
                <div className="privacy-policy-accordion">
                    <button
                        className={`privacy-policy-accordion-button ${isExpanded ? 'expanded' : ''}`}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        <span>{lang === 'EN' ? 'Detailed Privacy Terms' : 'विस्तृत गोपनीयता शर्तें'}</span>
                        <span className="accordion-icon">{isExpanded ? '−' : '+'}</span>
                    </button>

                    <div className={`privacy-policy-content-wrapper ${isExpanded ? 'expanded' : ''}`}>
                        <div className="privacy-policy-content-inner">
                            {/* Dynamically safely mapping structural language content paths */}
                            {currentPolicy.sections.map((section) => (
                                <div key={section.id} className="privacy-policy-section">
                                    <h3 className="privacy-policy-subtitle">
                                        {section.number}. {section.title}
                                    </h3>
                                    {section.paragraphs.map((para, index) => (
                                        <p key={index} className="privacy-policy-text">
                                            {para}
                                        </p>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Footer Section */}
                <div className="privacy-policy-footer">
                    <div className="privacy-policy-consent-row">
                        <div className="checkbox-col">
                            <input
                                type="checkbox"
                                id="privacy-accept"
                                className="privacy-policy-checkbox"
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                            />
                        </div>
                        <div className="label-col">
                            <label htmlFor="privacy-accept" className="privacy-policy-checkbox-label">
                                {lang === 'EN' ? 'I have read and agree to the privacy policy.' : 'मैंने गोपनीयता नीति पढ़ ली है और मैं इससे सहमत हूँ।'}
                            </label>
                        </div>
                    </div>

                    <button
                        className="privacy-policy-continue-btn"
                        onClick={handleContinue}
                        disabled={!isChecked}
                    >
                        {lang === 'EN' ? 'Continue' : 'जारी रखें'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WelcomePage;